import { HistoryLogRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class HistoryLogService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new HistoryLogRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default HistoryLogService;



// WEBPACK FOOTER //
// ./src/common/data/services/HistoryLogService.js